import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { environment } from '../../../../../environments/environment';

@Component({
  selector: 'app-seller-success',
  templateUrl: './seller-success.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SellerSuccessComponent {
  constructor(@Inject(DOCUMENT) private document: Document) {}

  public redirectHome(): void {
    this.document.location.href = environment.loginUrl;
  }
}
